import { Text } from '@thanx/uikit/text'
import DetailPanel from 'components/DetailPanel'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { merchantTheme } from 'theme'

const t = buildTranslate('order_ratings.rating_detail')

type Props = {
  // The customer's free-text comment, or null when they left none.
  comment: string | null
}

// The customer's comment, restructured (redesign phase 3) out of a
// Customer-comment tab into an always-visible card: a blockquote of the comment.
const CustomerResponseCard = ({ comment }: Props) => {
  const [css] = useStyletron()

  return (
    <DetailPanel>
      <Text.Header4>{t('customer_response.heading')}</Text.Header4>
      <div className={css({ marginTop: '12px' })}>
        {comment ? (
          <blockquote
            className={css({
              margin: 0,
              padding: '16px 18px',
              borderLeft: `3px solid ${merchantTheme.colors.grey40}`,
              backgroundColor: merchantTheme.colors.grey10,
            })}
          >
            <Text.BodyText4 tag="p" color="grey90" className="m-0">
              {comment}
            </Text.BodyText4>
          </blockquote>
        ) : (
          <Text.BodyText3 color="grey70">{t('comment_empty')}</Text.BodyText3>
        )}
      </div>
    </DetailPanel>
  )
}

export default CustomerResponseCard
